<template>
  <filter-parent v-if="showFilter" :title="texts.targetGroup">
    <multiselect
      v-if="!isLoadingCompetenceAreas"
      v-model="targetGroups"
      :options="targetGroupOptions"
      :placeholder="texts.startTyping"
    />
    <multiselect-filter-loader v-else />
  </filter-parent>
</template>

<script>
import FilterParent from '../common/FilterParent.vue';
import Multiselect from 'Components/MultiSelect.vue';
import MultiselectFilterLoader from './MultiselectFilterLoader.vue';
import { mapState } from 'vuex';

export default {
  name: 'TargetGroupFilter',

  components: {
    FilterParent,
    Multiselect,
    MultiselectFilterLoader,
  },

  data() {
    return {
      texts: theme_vars.counselorGridTexts,
    };
  },

  computed: {
    ...mapState('counselorGrid', [
      'targetGroupOptions',
      'isLoadingCompetenceAreas',
    ]),

    showFilter() {
      return (
        this.isLoadingCompetenceAreas || this.targetGroupOptions.length > 0
      );
    },

    targetGroups: {
      get() {
        return this.$store.state.counselorGrid.filteredTargetGroups;
      },
      set(value) {
        this.$store.commit('counselorGrid/setFilteredTargetGroups', value);
      },
    },
  },
};
</script>
